import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "redirectState",
  storage: sessionStorage,
});

export const redirectState = atom<string>({
  key: "redirectState",
  default: "",
  effects_UNSTABLE: [persistAtom],
});
